import { FuseNavigation } from '@fuse/types';
import { PortalAuthority } from '@appshared';

export const saleMenuItemIds = {
  saleReconciledId: 'sale-reconciled',
  txNotFoundId: 'sale-transaction-not-found',
  orderNotFoundId: 'sale-order-not-found'
};

export const saleNavigation: FuseNavigation[] = [
  {
    id: 'sale-data-reconciliation',
    title: 'Dữ liệu cần xử lý',
    translate: 'SALE.DATA_RECONCILIATION',
    roles: [PortalAuthority.FUNC__FUNC_VIEW__SALE_DATA],
    type: 'collapsable',
    svgIcon: 'artstuff_reconciliation',
    children: [
      {
        id: saleMenuItemIds.saleReconciledId,
        title: 'Cần đối soát',
        translate: 'SALE.TO_BE_RECONCILE_DATA',
        roles: [PortalAuthority.FUNC__FUNC_VIEW__SALE_DATA],
        type: 'item',
        icon: '',
        url: '/sale/tickets/to-be-reconcile',
        badge: {
          title: 0,
          bg: '#F36022',
          fg: '#FFFFFF',
        },
      },
      {
        id: saleMenuItemIds.txNotFoundId,
        title: 'Không có thanh toán',
        translate: 'SALE.TRANSACTION_NOT_FOUND',
        roles: [PortalAuthority.FUNC__FUNC_VIEW__SALE_DATA],
        type: 'item',
        icon: '',
        url: '/sale/tickets/transaction-not-found',
        badge: {
          title: 0,
          bg: '#F36022',
          fg: '#FFFFFF',
        },
      },
      {
        id: saleMenuItemIds.orderNotFoundId,
        title: 'Không có đơn hàng',
        translate: 'SALE.ORDER_NOT_FOUND',
        roles: [PortalAuthority.FUNC__FUNC_VIEW__SALE_DATA],
        type: 'item',
        icon: '',
        url: '/sale/tickets/order-not-found',
        badge: {
          title: 0,
          bg: '#F36022',
          fg: '#FFFFFF',
        },
      },
    ],
  },
  {
    id: 'sale-master-list',
    title: 'Dữ liệu tổng hợp',
    translate: 'SALE.MASTER_LIST',
    roles: [PortalAuthority.FUNC__FUNC_VIEW__SALE_DATA],
    type: 'item',
    svgIcon: 'artstuff_leaderboard',
    url: '/sale/tickets/master-list',
  },
  {
    id: 'sale-collection',
    title: 'Cơ sở dữ liệu',
    translate: 'SALE.DATA_MANAGEMENT',
    roles: [PortalAuthority.FUNC__FUNC_VIEW__PAYMENT_DATA],
    type: 'collapsable',
    svgIcon: 'artstuff_cloud_queue',
    children: [
      {
        id: 'payment-upload-history',
        title: 'Lịch sử thanh toán',
        translate: 'SALE.PAYMENT_HISTORY',
        roles: [PortalAuthority.FUNC__FUNC_VIEW__PAYMENT_DATA],
        type: 'item',
        icon: '',
        url: '/sale/payment-upload-history',
      },
      {
        id: 'payment-synchronization-log',
        title: 'Lịch sử đồng bộ',
        translate: 'SALE.SYNCHRONIZATION_LOG',
        roles: [PortalAuthority.FUNC__FUNC_SYNC_MYSQL__PAYMENT_DATA],
        type: 'item',
        icon: '',
        url: '/sale/sync-log',
      },
    ],
  },
];
